import {register} from '../vendor/theme-scripts/theme-sections';
import toggleGrid from '../features/collection-grid-toggle';
import accordion from '../features/accordion';
import {swatchGridSection} from '../features/swatch';
import popoutSection from '../features/popout';
import collectionFiltersSidebar from '../features/collection-filters-sidebar';
import collectionFiltersForm from '../features/collection-filters-form';
import {tooltipSection} from '../features/tooltip';
import hideElement from '../util/hide-element';

import axios from 'redaxios';

var selectors = {
  sort: '[data-sort-enabled]',
  sortLinks: '[data-sort-link]',
  sortValue: 'data-value',
  collectionNavGrouped: '[data-tag-group]',
  linkAdd: '.link--add',
  linkRemove: '.link--remove',
};

class Collection {
  constructor(section) {
    this.container = section.container;
    this.sort = this.container.querySelector(selectors.sort);
    this.sortLinks = this.container.querySelectorAll(selectors.sortLinks);
    this.enableInfiniteScroll = ( this.container.getAttribute('data-infinite-scroll') == 'true' );
    this.init();
  }

  init() {
    if (this.sort) {
      this.initClick();
    }
    this.removeUnusableFilters();

    if (this.enableInfiniteScroll) {
      this.infiniteScroll();
    }
  }

  removeUnusableFilters() {
    // temp tag filters
    const collectionNavGrouped = this.container.querySelectorAll(selectors.collectionNavGrouped);
    if (collectionNavGrouped.length > 0) {
      collectionNavGrouped.forEach((element) => {
        const linkAdd = element.querySelector(selectors.linkAdd);
        const linkRemove = element.querySelector(selectors.linkRemove);

        if (!linkAdd && !linkRemove) {
          hideElement(element);
        }
      });
    }
  }

  onClick(e) {
    const sort = e.currentTarget.getAttribute(selectors.sortValue);
    const url = new window.URL(window.location.href);
    const params = url.searchParams;
    params.set('sort_by', sort);
    url.search = params.toString();
    window.location.replace(url.toString());
  }

  initClick() {
    this.sortLinks.forEach((link) => {
      link.addEventListener(
        'click',
        function (e) {
          this.onClick(e);
        }.bind(this)
      );
    });
  }

  infiniteScroll() {
    const container = this.container,
          collectionProductGrid = this.container.querySelector(`[data-collection-product-grid]`),
          pagination = this.container.querySelector(`[data-pagination]`);

    if( pagination === null ) {
      return;
    }
    document.addEventListener('theme:scroll', function(){
      if( (window.scrollY+window.outerHeight) >= pagination.offsetTop ) {
        if( container.classList.contains('loading') ) {
          return;
        }
        if( container.querySelector(`[data-pagination-next]`) === null ) {
          return;
        }
        container.classList.add('loading');
        pagination.classList.add('loading');
        let url = container.querySelector(`[data-pagination-next]`).getAttribute('href');
        // console.log(`*** start fetching ${url} ***`);
        axios
          .get(url)
          .then(function (response) {
            // handle success
            const fresh = document.createElement('div');
            fresh.innerHTML = response.data;

            collectionProductGrid.insertAdjacentHTML( 'beforeend', fresh.querySelector('[data-collection-product-grid]').innerHTML );
            container.classList.remove('loading');

            pagination.innerHTML = fresh.querySelector('[data-pagination]').innerHTML;
            pagination.classList.remove('loading');

            window.history.pushState({}, '', url);
          })
          .catch(function (error) {
            console.warn(error);
          });
      }
    });
  }
}

const collectionSection = {
  onLoad() {
    this.collection = new Collection(this);
  },
};

register('collection', [collectionSection, popoutSection, collectionFiltersSidebar, collectionFiltersForm, toggleGrid, swatchGridSection, tooltipSection, accordion]);
